import * as exampleData from '@uifabric/example-data';

/** @deprecated Use `IExampleItem` from `@uifabric/example-data` instead */
export type IExampleItem = exampleData.IExampleItem;

/** @deprecated Use `createListItems` from `@uifabric/example-data` instead */
export const createListItems = exampleData.createListItems;

/** @deprecated Use `createGroups` from `@uifabric/example-data` instead */
export const createGroups = exampleData.createGroups;

/** @deprecated Use `lorem` from `@uifabric/example-data` instead */
export const lorem = exampleData.lorem;

/** @deprecated Use `isGroupable` from `@uifabric/example-data` instead */
export const isGroupable = exampleData.isGroupable;
